<template>
  <div class="new-client-main-container">
    <t-form :onSubmit="register" :schema="schema">
      <div class="info-item">
        <div class="title-new-user">Company</div>
        <div class="info-value">
          <t-input-text
            v-model="company"
            name="company"
            :onInputText="onInput"
            style="max-width: 304px"
            :placeholder="'Your company name'"
          />
          <div class="option-new-user">Optionnal</div>
        </div>
      </div>

      <div class="info-item">
        <div class="title-new-user">Last name</div>
        <t-input-text
          v-model="customer.lastName"
          :onInputText="onInput"
          name="lastName"
          style="max-width: 304px"
          :placeholder="'Your familly name'"
        />
      </div>
      <div class="info-item">
        <div class="title-new-user">First name</div>
        <t-input-text
          v-model="customer.firstName"
          :onInputText="onInput"
          name="firstName"
          style="max-width: 304px"
          :placeholder="'Your first name'"
        />
      </div>
      <div class="info-item">
        <div class="title-new-user">Email</div>
        <t-input-text
          v-model="customer.email"
          :onInputText="onInput"
          name="email"
          style="max-width: 304px"
          :placeholder="'Your email address for confirmation'"
        />
      </div>
      <div class="info-item">
        <div class="title-new-user">Password</div>
        <div class="info-value">
          <t-input-text
            v-model="customer.password"
            :onInputText="onInput"
            name="password"
            style="max-width: 304px"
            :placeholder="'Password'"
            type="password"
          />
        </div>
      </div>
      <div class="info-item">
        <div class="title-new-user">Confirm Password</div>
        <div class="info-value">
          <t-input-text
            type="password"
            v-model="customer.confirmPassword"
            name="confirmPassword"
            style="max-width: 304px"
            :onInputText="onInput"
            :placeholder="'Confirm Password'"
          />
        </div>
      </div>
      <div class="title-create">account now</div>
      <div class="track-title">if you want to track your order delivery</div>
      <div class="submit-btn-container">
        <t-button type="submit" :label="'Register'" color="secondary" />
      </div>
    </t-form>
  </div>
</template>
<script>
import { REGISTER_REQUEST } from "../../../authentication/store/actions";
import TForm from "../../../../common/components/TForm.vue";
import TInputText from "../../../../common/components/input-text/TInputText.vue";
import TButton from "../../../../common/components/buttons/TButton.vue";
import * as Yup from "yup";
import { reactive } from "@vue/reactivity";

export default {
  components: {
    TInputText,
    TForm,
    TButton,
  },
  data() {
    return {
      customer: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        confirmPassword: null,
      },
      company: null,
    };
  },
  setup() {
    let responseRegisterError = reactive({
      message: "",
    });

    const onInput = () => {
      responseRegisterError.message = "";
    };

    const schema = Yup.object().shape({
      firstName: Yup.string().required().label("First name"),
      lastName: Yup.string().required().label("Last name"),
      email: Yup.string().required().email().label("Email"),
      password: Yup.string().required().min(6).label("Password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .label("Confirm Password"),
      company: Yup.string(),
    });
    return {
      schema,
      responseRegisterError,
      onInput,
    };
  },
  methods: {
    register() {
      var that = this;
      this.$store
        .dispatch(REGISTER_REQUEST, this.customer)
        .then((res) => {
          that.customer = JSON.parse(localStorage.getItem("customer"));
          if (that.company) {
          }
        })
        .catch((e) => {
          that.responseRegisterError.message = e.response.data.message;
        });
    },
  },
};
</script>
<style lang="scss">
@import "../../style/NewUser.scss";
</style>
